import React from "react";
import { Skeleton } from "./ui/skeleton";

export function TableSkeleton({ rows = 6, cols = 7, testid = "skeleton-table" }) {
    return (
        <div className="w-full" data-testid={testid}>
            <div className="px-4 py-3" style={{ background: "var(--asl-navy-50)", borderBottom: "1px solid var(--asl-border)" }}>
                <div className="flex gap-4">
                    {Array.from({ length: cols }).map((_, i) => (
                        <Skeleton key={i} className="h-3 w-20" />
                    ))}
                </div>
            </div>
            <div className="divide-y" style={{ borderColor: "var(--asl-border)" }}>
                {Array.from({ length: rows }).map((_, r) => (
                    <div key={r} className="flex gap-4 px-4 py-4">
                        {Array.from({ length: cols }).map((_, c) => (
                            <Skeleton key={c} className={`h-4 ${c === 0 ? "w-32" : c === cols - 1 ? "w-16 ml-auto" : "w-24"}`} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export function KpiSkeleton({ count = 4, testid = "skeleton-kpis" }) {
    return (
        <div className={`grid grid-cols-2 md:grid-cols-${Math.min(count, 4)} lg:grid-cols-${Math.min(count, 8)} gap-3`} data-testid={testid}>
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="asl-card p-4 space-y-2">
                    <Skeleton className="h-3 w-20" />
                    <Skeleton className="h-7 w-24" />
                </div>
            ))}
        </div>
    );
}

export function BarChartSkeleton({ rows = 4, testid = "skeleton-bars" }) {
    return (
        <div className="space-y-3" data-testid={testid}>
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="space-y-1.5">
                    <div className="flex justify-between">
                        <Skeleton className="h-3 w-12" />
                        <Skeleton className="h-3 w-32" />
                    </div>
                    <Skeleton className="h-3 w-full" />
                </div>
            ))}
        </div>
    );
}

export { Skeleton };
